import $ from "jquery";

//=================================================================================================
import { AzureFileUploadHelper } from './azure-file-upload-helper';
import { AbideFunctionMapper } from './abide-function-mapper';
import '../../../../node_modules/jquery-mask-plugin/src/jquery.mask';
import './file-upload-validation';

//---------------------------------------------------------------------------------------------
// Description
//  - ServiceRequestUI logic supports:
//    - phone input field formatting (via InputPhoneFormatter)
//    - sequencing uploading files to ABS followed by AJAX call for the form submission
//    - handles displaying of error message from file upload or form submission via AJAX
//      errors
//---------------------------------------------------------------------------------------------
export function RequestServiceUI()
{
    var obj = {
        reset: reset,
        azFileUploadHelper: null,
        form: null,
        submitServiceRequest: submitServiceRequest,
        filesUploaded: [],
        uploadFiles: uploadFiles,
        onUploadProgress: onUploadProgress,
        submitForm: submitForm,
        showErrorMessage: showErrorMessage
    };

    obj.azFileUploadHelper = AzureFileUploadHelper();
    obj.form = $('#form-msh-request-service');
    obj.fileInputIds = ["file1", "file2", "file3"]; // file input  element ids

    obj.submitButton = document.getElementById("submit-button");
    
    obj.$phone = $('#input-phone');
    obj.$phone.mask('(000) 000-0000');
    obj.$phone.change(function()
    {
        var value = obj.$phone.val();
        value = value.replace(/\D/g, "");
        if (value && value.length == 10)
        {
            $(this).attr("aria-label",formatForWCAG(value))
        }

        function formatForWCAG(phone)
        {
            if (phone && phone.length == 10)
            {
                // format: "0 0 0. 0 0 0. 0 0 0 0.";
                return phone[0] + " " + phone[1] + " " + phone[2] + ". " + phone[3] + " " + phone[4] + " " + phone[5] + ". " + + phone[6] + " " + phone[7] + " " + phone[8] + " " + phone[9] + ".";
            }
        }
    })
    return obj;

    function reset() {
        // hide error message
        // enable submit button
        // remove files
        obj.filesUploaded = [];
        obj.submitButton.disabled = false;
    }

    //---------------------------------------------------------------------------------------------
    // Abide Calls this function but shows a spinner before calling this function.
    // Sequence -> User clicks submit, abide validates UI, if valid, abide shows spinner, then
    // calls this function.  This function call the callback which hides the spinner in the abide
    // code.
    //---------------------------------------------------------------------------------------------
    function submitServiceRequest(callback)
    {
        obj.filesUploaded = [];
        obj.cbAbide  = callback;
        obj.showErrorMessage(null, true);
        obj.submitButton.disabled = true;
        obj.postData = getFormObjectFromID("form-msh-request-service");
        obj.lotCostCenter = obj.postData && obj.postData.lotcostcenter ? obj.postData.lotcostcenter : "lotCostCenter";
        obj.adId = obj.postData.adid;

        obj.uploadFiles().then(
            function (result) {
                if (obj.filesUploaded.length == 0 || obj.filesUploaded.length == obj.azFileUploadHelper.files.length) {
                    obj.submitForm().then(function()
                    {
                        if (!window.patternLibrary) // set in the sevice request page but only in the pattern library
                        {
                            // MVC code - redirect to the confirmation page
                            window.location.replace(obj.confirmationPageUri);
                        }
                        obj.submitButton.disabled = false;
                        if (obj.cbAbide) obj.cbAbide(); // calls back into abide.js to hide the spinner
                    }, function()
                    {
                        obj.showErrorMessage("An issue occurred with submitting your service request.  Please try again or contact our office.");
                        obj.submitButton.disabled = false;
                        if (obj.cbAbide) obj.cbAbide(); // calls back into abide.js to hide the spinner
                    })
                } else {
                    obj.showErrorMessage("An issue occurred with uploading files.  Please try again or contact our office.");
                    obj.submitButton.disabled = false;
                    if (obj.cbAbide) obj.cbAbide(); // calls back into abide.js to hide the spinner
                }
            },
            function (rspErr) {
                if (rspErr.Code == "3333") // config call failed, force a redirect to login
                {
                    window.location.href = "/acct/signout/";
                } else {
                    obj.showErrorMessage("An issue occurred with uploading files.  Please try again or contact our office.");
                    obj.submitButton.disabled = false;
                    if (obj.cbAbide) obj.cbAbide(); // calls back into abide.js to hide the spinner
                }
            }
        );
    }    

    //-------------------------------------------------------------------------------------------------
    // Pulls files form input elements to pass to fileuploadhelper and then calls helper to upload
    // files
    //-------------------------------------------------------------------------------------------------
    function uploadFiles()
    {
        return new Promise(function(resolve, reject){
            try
            {
                var config = {
                    fileInputFieldIds: obj.fileInputIds,
                    isLoggedInMSHUserRequired: true,
                    adId: obj.adId,
                    lotCostCenterId: obj.lotCostCenter,
                    storageContext: "service-request"
                };

                obj.azFileUploadHelper.initialize(config);
                obj.azFileUploadHelper.uploadFiles(function (result, message, rspObj) {
                    if (result && resolve) {
                        resolve(rspObj) // can be null
                    }
                    else if (rspObj && reject) {
                        reject(rspObj);
                    };
                }, obj.onUploadProgress);
            }
            catch (err)
            {
                if (reject) reject();
            }
        });
    }

    //-------------------------------------------------------------------------------------------------
    // Called by fileuploadhelper to show upload progress
    //-------------------------------------------------------------------------------------------------
    function onUploadProgress(progress)
    {
        if (progress.succeeded) {
            obj.filesUploaded.push(progress.file);
        }
    }

    //-------------------------------------------------------------------------------------------------
    // Form submission logic via AJAX to kentico.
    // This occurs after the files are upload to Azure Blob Storage
    //-------------------------------------------------------------------------------------------------
    function submitForm()
    {
        return new Promise(function(resolve, reject)
        {
            try
            {
                if (window.patternLibrary) // set in the sevice request page but only in the pattern library
                {
                    setTimeout(function()
                    {
                        if (resolve) resolve();                
                    },500);
                    return;
                }
                
                var postData = getFormObjectFromID("form-msh-request-service");
                postData.fileattachmenturls = [];
                var files = [];
                for (var key in obj.filesUploaded) {
                    files.push(obj.filesUploaded[key]);
                }
                for (var key in files) {
                    postData.fileattachmenturls.push(files[key].uri);
                }
                // Get Anti-CSRF token
                var csrfToken = $("[name='__RequestVerificationToken']").val();

                $.ajax({
                    type: "POST",
                    url: obj.submitUri,
                    data: postData,
                    cache: false,
                    beforeSend: function (request) {
                        request.setRequestHeader("__RequestVerificationToken", csrfToken);
                    },                    
                    success: function (response) {
                        if (response.status && response.status == "OK") {
                            if (resolve) resolve(response);
                        }
                        else
                        {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                });
            }
            catch (err)
            {
                if (reject) reject("Error occurrect submittion form:" + err);
            }
        });
    }

    //-------------------------------------------------------------------------------------------------
    // Leverages the errorOutput element to show error messages from teh network
    //-------------------------------------------------------------------------------------------------
    function showErrorMessage(text, hide) {
        let el = document.getElementById("errorOutput");
        if (el) {
            if (!hide) {
                el.style = "display: block";
                let content = el.getElementsByClassName("alert-content");
                if (content) {
                    content[0].innerHTML = text;
                }
            } else {
                el.hide = "display: none";
            }
        }
    }

    //-------------------------------------------------------------------------------------------------
    // Constructs the postData object used in the AJAX submission to kentico
    //  - Also handles converting the radio selections for phone/email to preferredcontactmethod
    //-------------------------------------------------------------------------------------------------
    function getFormObjectFromID(formID) {
        var fields = {};
        $("#" + formID).find(":input").each(function () {
            // The selector will match buttons; if you want to filter
            // them out
            fields[this.name] = $(this).val();
        });
        var radioPhone = document.getElementById("msh-phone");
        var radioEmail = document.getElementById("msh-email");
        if (radioPhone && radioPhone.checked) fields.preferredcontactmethod = "Phone";
        else if (radioEmail && radioEmail.checked) fields.preferredcontactmethod = "Email";
        delete fields[""];
        delete fields["msh-contact-pref"];
        delete fields["msh-contact-pref"];
        delete fields.file1;
        delete fields.file2;
        delete fields.file3;
        if (fields.phone) fields.phone = fields.phone.replace(/[^0-9]/g, '');
        return fields;
    }    
};

//-------------------------------------------------------------------------------------------------
// Service Request Loaded
//-------------------------------------------------------------------------------------------------
$(document).ready(function ()
{
    var $formMshRequestService = $('#form-msh-request-service');
    if ($formMshRequestService.length)
    {
        var ui = RequestServiceUI();
        ui.submitUri = "/request-service/submitForm/";
        ui.confirmationPageUri = "/request-service/confirmation/";

        if (!window.abideFunctionMapper)
        {
            window.abideFunctionMapper = AbideFunctionMapper();
        }
        window.abideFunctionMapper.map("msh","forms","requestServiceSubmit",ui.submitServiceRequest);	
		
			//This will validate the Request Service form and set the focus to the first invalid input
		$(document)
			// field element is invalid
			.on("forminvalid.zf.abide", function (ev, elem) {
				var inputs = $("input.is-invalid-input");
				if (inputs.length > 0) {
					inputs[0].focus();
				} else {
					var textareas = $("textarea.is-invalid-input");
					if (textareas.length > 0) {
						textareas[0].focus();
					}
				}
			});
    }
});
